module.exports = __webpack_public_path__ + "media/img/masks/avatar-group-hover-754651d2ae4ecbf302d39546de0060e0.svg";